module.exports = __webpack_public_path__ + "img/web4.d5dc6b32.png";